import ProductName from './ProductName';
import Count from './Count';
import NetPrice from './NetPrice';
import GrossPrice from './GrossPrice';
import Vat from './Vat';
import SupplierName from './SupplierName';

export const labels = {
  ProductName: 'Terméknév',
  SupplierName: 'Beszállító',
  Vat: 'Áfa érték',
  NetPrice: 'Nettó érték',
  GrossPrice: 'Bruttó érték',
  Count: 'Db',
};

export const allColumns = [{
  value: 'SupplierName',
}, {
  value: 'ProductName',
}, {
  value: 'Vat',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'Count',
}];

export const defaultColumns = [{
  value: 'SupplierName',
}, {
  value: 'ProductName',
}, {
  value: 'Vat',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'Count',
}];

export default {
  SupplierName,
  ProductName,
  Vat,
  NetPrice,
  GrossPrice,
  Count
};
